import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./errorClientSlice";

const selectDomain = (state) => state.errorClient || initialState;

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);

export const makeSelectClientChosenError = createSelector(
  selectDomain,
  (state) => state.client_chosen_error
);
